/*
  WKS verlanglijst-hulpjes (blauwdrukpunt M6, 08-09-2026).

  1. Tellersync: vult [data-wishlist-count] bij het laden van de pagina en na
     elke hartje-klik (het thema vult de teller alleen na een klik, waardoor
     hij op nieuwe pagina's leeg bleef), en verbergt de tellerbubbel bij 0.
  2. Bevestigings-toast na toevoegen: "Bewaard in je verlanglijst - Bekijken",
     linkt naar de verlanglijstpagina. De hartje-klik zelf wordt volledig
     afgehandeld door de bestaande theme-handler op [data-wishlist]; die stopt
     de event-propagatie, daarom luistert dit script in de capture-fase.

  Terugdraaien: verwijder dit bestand plus het script-tag in layout/theme.liquid.
*/
(function () {
  function lijst() {
    try { return JSON.parse(localStorage.getItem('wishlistItem')) || []; } catch (e) { return []; }
  }

  function syncTeller() {
    var n = lijst().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (e) {
      e.textContent = n;
    });
  }

  var toastEl = null, toastTimer = null;
  function toonToast() {
    if (!toastEl) {
      var st = document.createElement('style');
      st.textContent =
        '#wks-wish-toast{position:fixed;left:50%;transform:translateX(-50%) translateY(16px);bottom:calc(88px + env(safe-area-inset-bottom));z-index:100;background:#1a1a1a;color:#fff;padding:12px 18px;border-radius:24px;font-size:13.5px;line-height:1;text-decoration:none;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap;box-shadow:0 4px 16px rgba(0,0,0,.25)}' +
        '#wks-wish-toast.is-zichtbaar{opacity:1;transform:translateX(-50%) translateY(0);pointer-events:auto}' +
        '#wks-wish-toast u{text-underline-offset:3px}' +
        '@media (prefers-reduced-motion: reduce){#wks-wish-toast{transition:none}}';
      document.head.appendChild(st);
      toastEl = document.createElement('a');
      toastEl.id = 'wks-wish-toast';
      toastEl.href = '/pages/wish-list';
      toastEl.innerHTML = '❤️ Bewaard in je verlanglijst &nbsp;·&nbsp; <u>Bekijken</u>';
      document.body.appendChild(toastEl);
    }
    toastEl.classList.add('is-zichtbaar');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-zichtbaar'); }, 2800);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-wishlist]') : null;
    if (!t) return;
    var voor = lijst().length;
    setTimeout(function () {
      var na = lijst().length;
      syncTeller();
      if (na > voor) toonToast();
    }, 180);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncTeller);
  }
  syncTeller();
  setInterval(syncTeller, 1500);
})();
